module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/6.19f1e945.jpg";